import React from 'react'
import ReactDOM from 'react-dom/client'
import Axios from 'axios'
import swal from 'sweetalert'
import './index.css'
import App from './App'
import './sentry-console-wrapper'
import * as Sentry from '@sentry/react'
// 🟡 Initialise Sentry AVANT le rendu
Sentry.init({
  dsn: 'https://efb94eb7962030447611862ecb0aec57@o4509440435486720.ingest.de.sentry.io/4509440625410128',
})

// Interceptor global: afficher un message clair quand une action est interdite côté API
let lastForbiddenToastAt = 0
Axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status
    if (status === 403) {
      const now = Date.now()
      // Eviter de spammer si plusieurs requêtes échouent en même temps
      if (now - lastForbiddenToastAt > 1500) {
        lastForbiddenToastAt = now
        const message = error?.response?.data?.message || 'Action non autorisée.'

        // Ne jamais bloquer le flux si swal échoue
        try {
          await swal('Action bloquée', message, 'info')
        } catch (e) {
          // noop
        }
      }
    }
    return Promise.reject(error)
  },
)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Une erreur est survenue.</p>} showDialog>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
